<template>
  <div class="Right">
    <!-- <div>
      <img src="../assets/images/25.jpg" alt="" />
      <p>关注大儒</p>
    </div>
    <div>
      <img src="../assets/images/26.jpg" alt="" />
      <p>咨询热线</p>
    </div> -->
    <div @click="backTop" style="border: none">
      <img src="../assets/images/27.jpg" alt="" />
      <p>回到顶部</p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      var i = 50;
      document.documentElement.scrollTop -= i;
      if (document.documentElement.scrollTop > 0) {
        var c = setTimeout(() => this.backTop(), 16);
      } else {
        clearTimeout(c);
      }
    },
  },
};
</script>

<style scoped>
.Right {
  position: fixed;
  z-index: 1000;
  right: 0;
  bottom: 200px;
  width: 110px;
  background-color: #fff;
  cursor: pointer;
  border-top: 2px solid #187fce;
  border-left: 2px solid #187fce;
  border-bottom: 2px solid #187fce;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  overflow: hidden;
}
.Right > div {
  padding: 20px 0;
  text-align: center;
  border-bottom: 2px solid #e5e5e5;
}
.Right img {
  display: block;
  width: 40px;
  height: 40px;
  margin: 0 auto 10px;
}
</style>